import React, { useState, useEffect } from "react";
import { Button, message } from "antd";
import ScanInput from "./ScanInput";
import { showMessage } from "../../Components/Utils/message";

const Scan = () => {
  const [scannedValue, setScannedValue] = useState("");
  const [isScanned, setIsScanned] = useState(false);

  const handleValueChange = (value) => {
    setScannedValue(value);

    // If the value comes from a scanner (fast input), trigger API automatically
    if (value.length > 0 && !isScanned) {
      setIsScanned(true);
      handleButtonClick(value);
    }
  };

  // Handle API call
  const handleButtonClick = async (value = scannedValue) => {
    if (!value.trim()) {
      showMessage('error',"Please enter or scan a barcode!");
      return;
    }

    try {
      const response = await fetch(`https://jsonplaceholder.typicode.com/posts/1`);
      showMessage('success',`Scanned: ${value}, API Response: ${JSON.stringify(response.data)}`);
    } catch (error) {
      showMessage('error',"API call failed!");
    }

    setIsScanned(false); // Reset scanner detection
  };

  return (
    <div style={{ padding: 20 }}>
      <h2>Barcode Scanner Input</h2>
      <ScanInput onValueChange={handleValueChange} />
      <Button type="primary" onClick={() => handleButtonClick()} style={{ marginTop: 10 }}>
        Submit
      </Button>
    </div>
  );
};

export default Scan;
